
// eslint-disable-next-line import/no-named-as-default
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'

Swiper.use([ Navigation, Pagination ])

export default {
  props: {
    items: {
      type: Array,
      default () {
        return []
      }
    },
    quantityslides: {
      type: Number,
      default: 7
    },
    imagepath: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'carousel'
    },
    clase: {
      type: String,
      default: 'swiper-container'
    },
    title: {
      type: Boolean,
      default: false
    },
    description: {
      type: Boolean,
      default: false
    },
    showpagination: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    // eslint-disable-next-line no-new
    new Swiper(`.${this.clase}`, {
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      slidesPerView: this.quantityslides,
      spaceBetween: 20,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 30
        },
        1024: {
          slidesPerView: this.quantityslides,
          spaceBetween: 20
        }
      }
    })
  }
}
